export const buildUser = ({userID, custom, customIDs} = {}) => {
    const user = {};

    if (userID) {
        user.userID = userID;
    }

    if (custom) {
        user.custom = custom;
    }

    if (customIDs) {
        user.customIDs = customIDs;
    }

    return user;
};
